export * from '@primeuix/themes/nora/paginator';
export { default } from '@primeuix/themes/nora/paginator';
